var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-63e40189-22a9-4a6f-bf60-dbc74d42203e",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 15 15",
    style: {
      enableBackground: "new 0 0 15 15"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.86;}\n\t.st1{fill:#1D4927;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-9e95af51-e85b-43e9-9f16-5b8e26493ebe"
  }, /*#__PURE__*/React.createElement("g", {
    id: "uuid-39eabdba-9084-4a1d-a5a7-1d4ebbc50558",
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9.1,13.9c0.4-0.1,0.7-0.2,1-0.6c0.2-0.4,0.2-0.8-0.1-1.1c-0.3-0.4-0.7-0.7-1.1-1.1C7.8,9.9,6.6,8.8,5.5,7.7 c-0.2-0.2-0.1-0.2,0-0.3C7,5.9,8.4,4.5,9.8,3.1c0.3-0.3,0.5-0.8,0.3-1.3C9.9,1,8.9,0.9,8.3,1.5C7.6,2.2,6.9,2.9,6.2,3.6 c-1,1-1.9,2-2.9,3c-0.6,0.6-0.6,1.2,0,1.9c1.7,1.7,3.4,3.4,5.1,5.1C8.5,13.7,8.8,13.9,9.1,13.9L9.1,13.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow_left.ba7431ac23b572a903ff074870c7283a.svg";
export { ForwardRef as ReactComponent };